const { h } = require('preact');
const {
  Button,
  ChevronRightIcon,
  ChevronLeftIcon,
} = require('@design-system/react');
const classnames = require('classnames');

const getPaginationSlots = paginationSlots => {
  if (!paginationSlots) {
    return null;
  }
  return paginationSlots.map(slot => {
    const { selected, isEllipsis, respond, url, text } = slot;
    const slotClasses = classnames('slot', 'black', {
      selected,
      ellipses: isEllipsis,
      respond,
    });

    return (
      <div className={slotClasses} key={`page-${text}`}>
        {url ? (
          <a href={url} data-bhc={`page:${text}`} aria-label={`Page ${text}`}>
            {text}
          </a>
        ) : (
          text
        )}
      </div>
    );
  });
};

const Pagination = props => {
  const {
    displayPagination,
    previousPageUrl,
    previousPage,
    nextPage,
    nextPageUrl,
    resultsHtml,
    paginationSlots,
  } = props;

  if (!displayPagination) {
    return null;
  }

  return (
    <div className="pagination" data-bhw="PaginationLinks">
      <div className="pagination-links">
        <div>
          {previousPageUrl ? (
            <Button
              variant="secondary"
              as="a"
              rel="prev"
              href={previousPageUrl}
              className="previous"
              data-bhc="page:previous"
              aria-label="Previous page"
              icon={<ChevronLeftIcon />}
            >
              {previousPage}
            </Button>
          ) : (
            <span className="previous">{previousPage}</span>
          )}
        </div>

        <div className="pagination-numbers-container">
          {getPaginationSlots(paginationSlots)}
        </div>

        <div>
          {nextPageUrl ? (
            <Button
              variant="secondary"
              as="a"
              rel="next"
              href={nextPageUrl}
              className="next"
              data-bhc="page:next"
              aria-label="Next page"
              icon={<ChevronRightIcon />}
              iconPosition="right"
            >
              {nextPage}
            </Button>
          ) : (
            <span className="next">{nextPage}</span>
          )}
        </div>
      </div>
      <p
        className="results"
        dangerouslySetInnerHTML={{ __html: resultsHtml }}
      ></p>
    </div>
  );
};

module.exports = Pagination;
